
// To have projects added as cards to the project page, add projects to the list here.
//  1. Set your title, description, and link (unfortunately mandatory for now)
//  2. imgPath must point to an image in src/Assets/images/projects/

const projectList = { "projects" : [
    {
        "title": "Digital Pathology",
        "imgPath": "digital-pathology.png",
        "description": "Project Lead for 7-person Senior Project building and applying containerized deep learning infrastructure for medical diagnoses with AWS, Python, and PyTorch.",
        "link": "https://github.com/Digital-Pathology"
    },
    {
        "title": "Advanced Software Design (SE 575)",
        "imgPath": "software-patterns.png",
        "description": "Coursework for Graduate-level Software Engineering course: applying design patterns to various case studies using Java.",
        "link": "https://github.com/adinbsolomon/DrexelClasses"
    },
    {
        "title": "Deep Learning (CS 615)",
        "imgPath": "CS-615.png",
        "description": "Development of a Deep Learning framework and application to a variety of challenges using Python.",
        "link": "https://github.com/adinbsolomon/DrexelClasses"
    },
    {
        "title": "Heavy Metal",
        "imgPath": "heavy-metal.png",
        "description": "6-month Freshman Design series project: Virtual Reality Mechasuit FPS using Unity3d, C#, SteamVR, HTC-Vive",
        "link": "https://drive.google.com/file/d/1IoPEGahlgf1Fp-4G00tjaGABpd7f7KUv/view?usp=sharing"
    }
]}

export default projectList;